import AppContainer from '../containers/App'
import { isUserAuthenticated } from 'configs/auth'

export default {
  childRoutes: [
    {
      path: '/',
      component: isUserAuthenticated(AppContainer),
      indexRoute: {
        getComponent (partialNextState, cb) {
          require.ensure([], (require) => {
            cb(null, require('components/Home'))
          })
        }
      }
    },
    {
      path: '/login',
      getComponent (partialNextState, cb) {
        require.ensure([], (require) => {
          cb(null, require('containers/Login'))
        })
      }
    },
    {
      path: '/results/:jobId/:env/:apikey/:toJobId/:fromJobId',
      getComponent (partialNextState, cb) {
        require.ensure([], (require) => {
          cb(null, require('containers/RecognizeResults'))
        })
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/configs/routes.js